<template>
    <div class="p-4 border-b border-gray-200 space-y-2">
        <div class="text-lg font-semibold">{{ item.name }}</div>

        <!-- Location -->
        <ProductLocation :fullLocation="attributes.location" />

        <div class="flex gap-2 text-sm">
            <i class="icon-User-Groups text-gray-800 flex items-center text-lg justify-center"></i>
            <span>{{ $t('Max. number of people') }}</span>
            <span class="font-semibold">{{ attributes?.maxOccupancy }}</span>
        </div>

        <div v-if="attributes?.properties?.countBedrooms" class="flex gap-2 text-sm">
            <i class="icon-Bedroom text-gray-800 flex items-center text-lg justify-center"></i>
            <span>{{ $t('Bedrooms') }}</span>
            <span class="font-semibold">{{ attributes?.bedrooms || attributes?.properties?.countBedrooms }}</span>
        </div>

        <div class="flex gap-2 text-sm">
            <i class="icon-Dog text-gray-800 flex items-center text-lg justify-center"></i>
            <span>{{ $t('Pets allowed') }}</span>
            <span class="font-semibold">{{ attributes?.properties?.petsAllowed ? $t('Yes') : $t('No') }}</span>
        </div>
    </div>

    <div class="p-4 border-b border-gray-200">
        <h4 class="text-base mb-2 font-semibold">{{ $t('Your booking details') }}</h4>
        <div class="grid grid-cols-2 gap-2 divide-x divide-gray-200 pb-4 border-b border-gray-200 mb-4">
            <div>
                <h5 class="text-sm font-medium mb-2.5">{{ $t('Check in') }}</h5>
                <div class="text-[15px] font-semibold">{{ $d(attributes.checkIn, 'long') }}</div>
            </div>
            <div>
                <h5 class="text-sm font-medium mb-2.5">{{ $t('Check out') }}</h5>
                <div class="text-[15px] font-semibold">{{ $d(attributes.checkOut, 'long') }}</div>
            </div>
        </div>
        <div>
            <h5 class="text-sm font-medium mb-1.5">{{ $t('Number of nights and guests') }}:</h5>
            <div class="text-[15px] font-semibold">{{ $t('nights', { count: attributes.nights }) }} - {{ $t('guests', { count: guest_count }) }}</div>
        </div>
    </div>
</template>

<script setup>
const { item } = defineProps({
    item: {
        type: Object,
        required: true
    }
})

const attributes = computed(() => item.attributes ?? {})

const guest_count = computed(() => {
    const { adults = 0, teens = 0, children = 0 } = attributes.value.guests
    return adults + teens + children
})
</script>
